const roles = {
  /** @description CRIAR_USUARIO */
  CRIAR_USUARIO: 'CRIAR_USUARIO',

  /** @description IMPORTACAO_CARDS */
  IMPORTACAO_CARDS: 'IMPORTACAO_CARDS',

  /** @description IMPORTACAO_PLANILHA */
  IMPORTACAO_PLANILHA: 'IMPORTACAO_PLANILHA',

  /** @description ADMINISTRADOR */
  ADMINISTRADOR: 'ADMINISTRADOR',

  /** @description USUARIO_EXTERNO */
  USUARIO_EXTERNO: 'USUARIO_EXTERNO',

  /** @description MOVIMENTACAO */
  MOVIMENTACAO: 'MOVIMENTACAO',

  /** @description ACESSO_CAMPANHA */
  ACESSO_CAMPANHA: 'ACESSO_CAMPANHA',

  /** @description ACESSO_RELATORIOS */
  ACESSO_RELATORIOS: 'ACESSO_RELATORIOS',

  /** @description VISUALIZACAO_INFOS_PRIVADAS_ASSOCIADOS */
  VISUALIZACAO_INFOS_PRIVADAS_ASSOCIADOS: 'VISUALIZACAO_INFOS_PRIVADAS_ASSOCIADOS',

  /** @description DESBLOQUEAR_AJUIZAMENTO */
  DESBLOQUEAR_AJUIZAMENTO: 'DESBLOQUEAR_AJUIZAMENTO',

  /** @description ACESSO_AJUIZAMENTO */
  ACESSO_AJUIZAMENTO: 'ACESSO_AJUIZAMENTO'
}
export default roles



// WEBPACK FOOTER //
// ./src/shared/utils/roles.js